@if (visible()) {
  <div
    class="fixed bottom-5 inset-x-0 z-50 flex justify-center px-4 pointer-events-none"
    role="dialog" aria-modal="true" aria-label="Aviso de cookies"
  >
    <div
     
     
     class="pointer-events-auto w-full max-w-lg flex flex-col sm:flex-row items-start sm:items-center gap-4 bg-white rounded-2xl border border-pale-gray px-5 py-4 shadow-tfr-md">
      <!-- Icon -->
      <div class="h-9 w-9 shrink-0 rounded-xl flex items-center justify-center bg-cloud-mist">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke="currentColor" stroke-width="1.75" class="h-4 w-4 text-slate-blue">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>

      <!-- Text -->
      <p class="flex-1 text-[13px] leading-[1.6] text-slate-blue">
        Usamos cookies analíticas para mejorar la experiencia.
        <a routerLink="/privacidad"
           class="text-action-blue hover:underline font-medium focus:outline-none">
          Política de privacidad
        </a>
      </p>

      <!-- Actions -->
      <div class="flex items-center gap-2 shrink-0">
        <button (click)="reject()"
          class="px-3.5 py-1.5 rounded-lg text-[12px] font-medium text-slate-blue bg-cloud-mist
                 hover:bg-pale-gray transition-colors focus:outline-none focus:ring-2 focus:ring-steel-gray">
          Rechazar
        </button>
        <button (click)="accept()"
          class="px-3.5 py-1.5 rounded-lg text-[12px] font-semibold text-white bg-action-blue
                 hover:brightness-110 transition-all focus:outline-none focus:ring-2 focus:ring-action-blue/40">
          Aceptar
        </button>
      </div>
    </div>
  </div>
}
